import moment from "moment";

export const isDDMMYYYY = (str) => {
  if (str instanceof Object) return true;

  let [dd, mm, yyyy] = str.split(/[\.\/]/);
  dd = +dd;
  yyyy = +yyyy;
  let mm0 = mm - 1;
  let date = new Date(yyyy, mm0, dd, 15, 0, 0, 0);
  let fullDate = moment(str);
  return (
    mm0 === date.getMonth() &&
    dd === date.getDate() &&
    yyyy === date.getFullYear() &&
    fullDate.isSame(moment(`${dd}-${mm}-${yyyy}`))
  );
};
